var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDefaultAvatar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 118,
    viewBox: "0 0 118 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1945_13814",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 118,
    height: 118
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M117.6 58.8C117.6 91.27 91.27 117.6 58.8 117.6C26.33 117.6 0 91.27 0 58.8C0 26.33 26.33 0 58.8 0C91.27 0 117.6 26.33 117.6 58.8Z",
    fill: "#F9B233"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1945_13814)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.0698 93.1809C86.3698 88.5709 57.1298 78.4609 57.1298 78.4609C57.1298 78.4609 28.4998 89.6509 24.1798 93.1809C19.8698 96.7209 18.2598 119.061 18.2598 119.061H95.1498C95.1498 119.061 93.7598 97.7909 90.0698 93.1809Z",
    fill: "#003662"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1997 83.8483C66.1997 83.8483 65.5897 86.7883 62.1197 88.3383C60.8697 88.8983 59.2397 96.0283 57.1397 96.0283C54.9197 96.0283 53.2297 88.8583 51.9597 88.2383C48.6697 86.6583 48.0897 83.8483 48.0897 83.8483C48.0897 83.8483 50.2997 79.4583 48.0897 74.3083C45.8797 69.1583 68.9097 68.1083 66.2097 74.3083C63.5097 80.5083 66.2097 83.8483 66.2097 83.8483H66.1997Z",
    fill: "#DDA778"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.8097 63.3393C79.4997 55.7693 81.5297 44.6293 81.5297 44.6293C88.5097 29.0293 81.2697 5.50929 67.7397 12.7393C50.9997 -2.55071 24.5197 18.8293 33.4797 44.4193C33.4797 44.4193 34.5597 56.1293 36.2997 63.5893C38.2597 71.9793 52.7097 78.2093 57.1297 78.4593C61.5397 78.7093 76.0197 71.3593 77.8097 63.3493V63.3393Z",
    fill: "#281511"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.7396 49.0882C82.7396 53.1782 79.8396 58.7982 77.8896 58.7982C75.9396 58.7982 74.3496 55.4782 74.3496 51.3982C74.3496 47.3182 76.3496 45.1982 77.8896 43.9982C79.7796 42.5182 82.7396 43.9982 82.7396 49.0982V49.0882Z",
    fill: "#F9BB8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1099 49.0882C32.1099 53.1782 35.0099 58.7982 36.9599 58.7982C38.9099 58.7982 40.4999 55.4782 40.4999 51.3982C40.4999 47.3182 38.4999 45.1982 36.9599 43.9982C35.0699 42.5182 32.1099 43.9982 32.1099 49.0982V49.0882Z",
    fill: "#F9BB8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.51 16.6875C43.78 16.6875 37.71 26.3075 37.71 40.6575V58.6275C37.71 71.1275 52.15 81.8175 56.71 81.8175C61.27 81.8175 77.31 69.3175 77.31 57.4775V40.6575C77.31 26.3075 71.24 16.6875 57.51 16.6875Z",
    fill: "#F9BB8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.31 50.9006L78.55 40.4306C78.55 26.0806 71.24 15.3906 57.51 15.3906C43.78 15.3906 37 26.0806 37 40.4306L37.71 53.2006C37.71 53.2006 39.34 50.4606 39.19 46.4106C38.86 37.2006 45.31 36.3806 52.82 34.9406C64.66 32.6806 67.99 25.5806 67.99 25.5806C67.99 25.5806 71.87 26.8906 74.35 32.6806C75.95 36.4206 76.33 42.1506 76.2 44.5006C76.08 46.8406 77.31 50.9006 77.31 50.9006Z",
    fill: "#281511"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultAvatar);
export default __webpack_public_path__ + "static/media/defaultAvatar.16798ddbf7f076492f64bf0bc9bad5cb.svg";
export { ForwardRef as ReactComponent };